module.exports = __webpack_public_path__ + "img/user.540b988c.png";